import classnames from 'classnames';
import React, { FC } from 'react';

import { directionWrapperDataHooks } from './DirectionWrapper.dataHooks';
import s from './DirectionWrapper.scss';

interface DirectionWrapperProps {
  isRtl: boolean;
  className?: string;
}

export const DirectionWrapper: FC<DirectionWrapperProps> = ({ isRtl, children, className }) => {
  const classNames = classnames(className, {
    [s.rtl]: isRtl,
  });

  return (
    <div
      data-hook={isRtl ? directionWrapperDataHooks.rtl() : directionWrapperDataHooks.ltr()}
      className={classNames}
    >
      {children}
    </div>
  );
};
